import React from 'react';

const ViewQuiz = () => {
    return (
        <div>ViewQuiz</div>
    );
}

export default ViewQuiz;